stzh-search {
  @include host;

  --filter-background-color: var(
    --stzh-search-filter-background-color,
    #{$colorGrey10}
  );

  --grid-template-areas: "filters-main filters-main filters-main filters-main"
    "results results results results";

  @include mq($from: medium) {
    --grid-template-areas: "filters-main filters-main filters-main filters-main filters-main filters-main filters-main filters-main"
      "results results results results results results results results";
  }

  @include mq($from: large) {
    --grid-template-areas: "filters-main filters-main filters-main filters-main filters-main filters-main filters-main filters-main filters-main filters-main filters-main filters-main"
      ". . results results results results results results results results . .";
  }

  &:where(
    [has-aside-filters]:not(
      [hide-aside-filters]:not([hide-aside-filters="false"])
    )
  ) {
    --grid-template-areas: "filters-main filters-main filters-main filters-main"
      "filters-aside filters-aside filters-aside filters-aside"
      "results results results results";

    @include mq($from: medium) {
      --grid-template-areas: "filters-main filters-main filters-main filters-main filters-main filters-main filters-main filters-main"
        "filters-aside filters-aside filters-aside filters-aside filters-aside filters-aside filters-aside filters-aside"
        "results results results results results results results results";
    }

    @include mq($from: large) {
      --grid-template-areas: "filters-main filters-main filters-main filters-main filters-main filters-main filters-main filters-main filters-main filters-main filters-main filters-main"
        "filters-aside filters-aside filters-aside filters-aside results results results results results results results results";
    }
  }

  &:where([variant="teaser"]:not([has-aside-filters])),
  &:where([fullwidth="true"]:not([has-aside-filters])) {
    @include mq($from: large) {
      --grid-template-areas: "filters-main filters-main filters-main filters-main filters-main filters-main filters-main filters-main filters-main filters-main filters-main filters-main"
        "results results results results results results results results results results results results";
    }
  }
}

.stzh-search {
  @include grid;
  grid-template-areas: var(--grid-template-areas);

  &__header-heading {
    @include spaceCurve("margin-bottom", "small");
  }

  &__filters-main {
    grid-area: filters-main;

    &:not(:empty) {
      @include spaceCurve("padding", "medium");
      background-color: var(--filter-background-color);
    }
  }

  &__filters-aside {
    grid-area: filters-aside;

    &:not(:empty) {
      @include spaceCurve("padding", "medium");
      background-color: var(--filter-background-color);

      @include mq($from: large) {
        background-color: transparent;
        padding: 0;
      }
    }
  }

  &__filters-aside-heading {
    @include font("heavy");
    @include fontCurve("h4");
    @include spaceCurve("padding-bottom", "tiny");
    color: $colorPrimary70;
    display: none;

    @include mq($from: large) {
      display: block;
    }
  }

  stzh-button#{&}__filters-aside-details-trigger {
    @include mq($from: large) {
      display: none;
    }
  }

  &__filters-aside-inner {
    @include mq($from: large) {
      position: sticky;
      top: calc(
        var(--stzh-header-metabar-height, 0px) *
          var(--stzh-header-is-stuck, 0) + #{space("medium")}
      );
      transition: top $baseTransitionAnimationSpeed;
      width: calc(
        100% + #{$gridGutterLarge} - #{spaceCurveValue("large", "large")}
      );
    }

    @include mq($from: ultra) {
      width: calc(
        100% + #{$gridGutterUltra} - #{spaceCurveValue("large", "large")}
      );
    }
  }

  &__results-wrapper {
    grid-area: results;
    display: grid;
    --stzh-datalist-grid-template-areas: "list list list list list list list list";
  }

  &__results-header {
    display: flex;
    flex-direction: column;

    @include mq($from: medium) {
      flex-direction: row;
      align-items: center;
    }
  }

  &__results-sort {
    display: flex;
  }

  &__results-heading,
  &__results-empty,
  &__results,
  &__action-more {
    transition-property: opacity;
    transition-duration: $baseTransitionAnimationSpeed;
  }

  &__results-text,
  &__results-sort,
  &__results-subscribe {
    @include spaceCurve("margin-bottom", "regular");
  }

  &__results-heading {
    @include spaceCurve("margin-bottom", "small");

    @include mq($from: medium) {
      @include spaceCurve("margin-bottom", "regular");
    }
  }

  &__results-item {
    display: contents;
  }

  &__actions-wrapper {
    display: flex;
    justify-content: center;

    &:not(:empty) {
      @include spaceCurve("margin-top", "medium");
    }
  }

  &__empty-text {
    @include spaceCurve("margin-bottom", "regular");
  }

  &__loader {
    @include spaceCurve("margin-top", "medium");
  }

  &__filters-main-chips {
    @include spaceCurve("margin-top", "medium");
  }

  /* Teaser variant */

  &--teaser &__actions-wrapper {
    justify-content: flex-start;
  }

  //&--teaser &__filters-main {
  //  &:not(:empty) {
  //    padding: 0;
  //    background-color: transparent;
  //  }
  //}
  //
  //&--teaser &__filters-aside {
  //  &:not(:empty) {
  //    padding: 0;
  //    background-color: transparent;
  //  }
  //}

  /* Has results shown or aside filter */

  &--has-results-shown &__results-wrapper {
    @include mq($to: large) {
      @include spaceCurve("margin-top", "huge");
    }
  }

  &--has-results-shown &__filters-main,
  &--has-filters-aside &__filters-main {
    @include mq($from: large) {
      @include spaceCurve("margin-bottom", "large");
    }
  }

  &--has-results-shown#{&}--teaser &__results-wrapper {
    @include mq($to: large) {
      @include spaceCurve("margin-top", "medium");
    }
  }

  &--has-results-shown#{&}--teaser &__filters-main,
  &--has-filters-aside#{&}--teaser &__filters-main {
    @include mq($from: large) {
      @include spaceCurve("margin-bottom", "medium");
    }
  }

  /* Has main and aside filters */

  &--has-filters-main#{&}--has-filters-aside &__filters-main {
    &:not(:empty) {
      @include spaceCurve("padding-bottom", "regular");
    }
  }

  &--has-filters-main#{&}--has-filters-aside &__filters-aside {
    &:not(:empty) {
      padding-top: 0px;
    }
  }

  /* Has hidden main/aside filters */

  &--has-hidden-main-filters &__filters-main {
    display: none;
  }

  &--has-hidden-aside-filters &__filters-aside {
    display: none;
  }

  &--has-hidden-main-filters &__results-wrapper,
  &--has-hidden-main-filters#{&}--teaser &__results-wrapper {
    margin-top: 0px;
  }

  /* Is loading */

  &--is-loading &__results-heading,
  &--is-loading &__results-sort,
  &--is-loading &__results-empty,
  &--is-loading &__results,
  &--is-loading &__action-more {
    opacity: 0.5;
  }

  /* Is overlay */

  &--is-breakout {
    --filter-background-color: var(--stzh-color-cobaltblue20);
    background-color: var(--stzh-color-white);
  }

  &--is-breakout & {
    @include containerPadding();
  }

  &--is-breakout &__header-wrapper {
    background-color: var(--stzh-color-cobaltblue20);
  }

  &--is-breakout &__filters-main {
    @include containerPadding();
    position: relative;
    left: 50%;
    right: 50%;
    margin-left: calc(-50vw + var(--stzh-scrollbar-width) / 2);
    margin-right: calc(-50vw + var(--stzh-scrollbar-width) / 2);
    width: calc(100vw - var(--stzh-scrollbar-width));
    max-width: calc(100vw - var(--stzh-scrollbar-width));
  }

  &--is-breakout &__header {
    @include container();
    @include spaceCurve("padding-top", "medium");
    background-color: var(--stzh-color-cobaltblue20);
    display: flex;
    justify-content: space-between;
  }
}
